import { ChangeDetectorRef, OnInit, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { PricingService } from '../../services/pricing.service';
import { AppLoadingEventsEmitter } from 'src/app/modules/shared/events/loading.events';
import { Constants } from 'src/app/modules/shared/config/constants.config';
import { UsersService } from '../../../shared/services/users.service';
import { BraintreeBgTranslationConfig } from '../../../shared/config/braintree.bg.translation.config';
import { LocalisationService } from '../../../shared/services/localisation.service';
import { deleteCookie, getCookie } from '../../../shared/utilities/cookie.utilities';
import { Languages } from '../../../shared/enums/languages';
import { StarsService } from '../../../shared/services/stars.service';
import { StorageService } from '../../../shared/services/storage.service';
import * as moment from 'moment';
var PricingComponent = /** @class */ (function () {
    function PricingComponent(changeDetectorRef, pricingService, appIsLoadingEventsEmitter, localStorage, router, constants, usersService, localisationService, braintreeBgTranslationConfig, starsService) {
        this.changeDetectorRef = changeDetectorRef;
        this.pricingService = pricingService;
        this.appIsLoadingEventsEmitter = appIsLoadingEventsEmitter;
        this.localStorage = localStorage;
        this.router = router;
        this.constants = constants;
        this.usersService = usersService;
        this.localisationService = localisationService;
        this.braintreeBgTranslationConfig = braintreeBgTranslationConfig;
        this.starsService = starsService;
        this.mobileWidth = 576;
        this.showYearlyPricing = false;
        this.showBraintree = false;
        this.currentUserIsReferral = false;
        this.discountCode = null;
        this.masterProfile = false;
        this.yettelToken = null;
    }
    PricingComponent.prototype.ngOnInit = function () {
        var _this_1 = this;
        this.masterProfile = (this.usersService.userProfile && this.usersService.userProfile.is_master_profile === true);
        this.pricingService.getYettelSubscription().subscribe(function (yettelSubscription) {
            if (yettelSubscription.subscription_already_exists === true) {
                _this_1.yettelToken = null;
            }
            else {
                _this_1.yettelToken = _this_1.usersService.userProfile.yettel_token;
            }
        });
        this.usersService.getUserSubscription().subscribe(function (currentSubscription) {
            if (currentSubscription && currentSubscription.pricing_plan.id != _this_1.getFreePricingPlanId()) {
                _this_1.router.navigate(['/invoices']);
            }
            else {
                _this_1.load().subscribe();
            }
        }, function () {
            _this_1.load().subscribe();
        });
    };
    PricingComponent.prototype.getFreePricingPlanId = function () {
        return 4;
    };
    PricingComponent.prototype.load = function () {
        var _this_1 = this;
        this.openAllTooltips();
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        return new Observable(function (observer) {
            forkJoin([
                _this_1.pricingService.getPricings(),
                _this_1.pricingService.getPaymentMethods(),
                _this_1.usersService.getIsCurrentUserReferral()
            ]).subscribe(function (_a) {
                var pricings = _a[0], paymentMethods = _a[1], isCurrentUserReferral = _a[2];
                var new_pricings = pricings.filter(function (pricing) { return pricing.show_for_master_profiles === _this_1.masterProfile && pricing.id > 4; });
                _this_1.pricings = new_pricings.sort(function (a, b) { return +a.amounts[0].monthly_price - +b.amounts[0].monthly_price; });
                _this_1.paymentMethods = paymentMethods;
                _this_1.currentUserIsReferral = isCurrentUserReferral.is_user_referral && isCurrentUserReferral.referral_plan_discounts;
                _this_1.onPaymentMethodSelected(paymentMethods[0]);
                _this_1.changeDetectorRef.markForCheck();
                var discountCookie = getCookie('discount');
                var starCookie = _this_1.localStorage.getItem('star');
                if (starCookie === null || starCookie.length < 0) {
                    starCookie = getCookie('star');
                }
                if ((starCookie === null || starCookie.length <= 0) && !(discountCookie === null || discountCookie.length <= 0)) {
                    _this_1.applyDiscountForAllPlans(discountCookie);
                }
                if (!(starCookie === null || starCookie.length <= 0)) {
                    _this_1.applyStarPrice(starCookie);
                }
                else {
                    _this_1.influencer = null;
                }
                _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                observer.next(true);
                observer.complete();
            });
        });
    };
    PricingComponent.prototype.onChoose = function (pricing) {
        this.currentlySelectedPricing = pricing;
        if (!this.isTrialPlan(pricing)) {
            this.bootBraintree();
        }
        else {
            this.createFreeSubscription();
        }
    };
    PricingComponent.prototype.onPaymentMethodSelected = function (paymentMethod) {
        this.currentlySelectedPaymentMethod = paymentMethod;
    };
    PricingComponent.prototype.applyDiscountCode = function () {
        var _this_1 = this;
        var discountCode = prompt(this.localisationService.localise('enter_discount_code'), '');
        if (discountCode === null) {
            return;
        }
        discountCode = discountCode.trim();
        this.load().subscribe(function () {
            if (discountCode.length <= 0) {
                _this_1.discountCode = null;
            }
            else {
                _this_1.applyDiscountForAllPlans(discountCode);
            }
        });
    };
    PricingComponent.prototype.applyDiscountForAllPlans = function (discountCode) {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.pricingService.getDiscount({ 'discount_code': discountCode }).subscribe(function (discount) {
            _this_1.discountCode = discount;
            // tslint:disable-next-line:forin
            for (var pricingIndex in _this_1.pricings) {
                // tslint:disable-next-line:forin
                for (var amountIndex in _this_1.pricings[pricingIndex].amounts) {
                    // @ts-ignore
                    if (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price <= 0) {
                        continue;
                    }
                    // @ts-ignore
                    _this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price = (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price - (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price * (_this_1.getDiscountPercentageByLocale(_this_1.discountCode) / 100))).toFixed(2);
                }
            }
            _this_1.pricings = _this_1.pricings.sort(function (a, b) { return +a.amounts[0].monthly_price - +b.amounts[0].monthly_price; });
            _this_1.changeDetectorRef.markForCheck();
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        }, function () {
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    PricingComponent.prototype.getDiscountPercentageByLocale = function (discount) {
        // tslint:disable-next-line:forin
        for (var amountIndex in discount.amounts) {
            if (this.localisationService.getLanguage() === Languages.Bulgarian && discount.amounts[amountIndex].language.country_code === 'BG') {
                return discount.amounts[amountIndex].percentage;
            }
            if (this.localisationService.getLanguage() === Languages.English && discount.amounts[amountIndex].language.country_code === 'EN') {
                return discount.amounts[amountIndex].percentage;
            }
        }
    };
    PricingComponent.prototype.isTrialPlan = function (pricing) {
        return !+this.getLanguagePricingAmount(pricing).monthly_price;
    };
    PricingComponent.prototype.requestPaymentMethod = function () {
        var _this_1 = this;
        this.getSubscriptionChargeAmount()
            .subscribe(function (data) {
            _this_1.braintreeInstance.requestPaymentMethod({
                threeDSecure: {
                    amount: data['amount'],
                    email: _this_1.usersService.userProfile.email,
                    billingAddress: {
                        givenName: _this_1.usersService.userProfile.first_name,
                        surname: _this_1.usersService.userProfile.last_name,
                        phoneNumber: _this_1.usersService.userProfile.phone,
                        streetAddress: '',
                        extendedAddress: '',
                        locality: '',
                        region: '',
                        postalCode: '',
                        countryCodeAlpha2: ''
                    },
                    additionalInformation: {
                        workPhoneNumber: _this_1.usersService.userProfile.phone,
                        shippingGivenName: _this_1.usersService.userProfile.first_name,
                        shippingSurname: _this_1.usersService.userProfile.last_name,
                        shippingPhone: _this_1.usersService.userProfile.phone,
                        shippingAddress: {
                            streetAddress: '',
                            extendedAddress: '',
                            locality: '',
                            region: '',
                            postalCode: '',
                            countryCodeAlpha2: ''
                        }
                    },
                }
            }, function (requestPaymentMethodErr, payload) {
                if (typeof payload !== 'undefined') {
                    _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
                    _this_1.pricingService
                        .createSubscription({
                        payment_method: _this_1.currentlySelectedPaymentMethod ? _this_1.currentlySelectedPaymentMethod.id : undefined,
                        pricing: _this_1.currentlySelectedPricing.id,
                        client_nonce: payload.nonce,
                        referral: getCookie('referral'),
                        locale: _this_1.localisationService.getLanguage(),
                        set_discount: _this_1.getLanguagePricingAmount(_this_1.currentlySelectedPricing).discount_monthly_price.length > 0 && _this_1.currentUserIsReferral === true,
                        discount_code: _this_1.discountCode ? _this_1.discountCode.code : null,
                        influencer_id: _this_1.influencer ? _this_1.influencer.influencer.id : null,
                        charge_yearly: _this_1.showYearlyPricing
                    })
                        .subscribe(function () {
                        _this_1.router.navigate(['dashboard']).then(function () {
                            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                        });
                    }, function () {
                        alert(_this_1.localisationService.localise('transaction_failed'));
                        window.location.reload();
                    });
                }
            });
        }, function () {
            alert(_this_1.localisationService.localise('transaction_failed'));
            window.location.reload();
        });
    };
    PricingComponent.prototype.getSubscriptionChargeAmount = function () {
        return this.pricingService
            .createSubscription({
            payment_method: this.currentlySelectedPaymentMethod ? this.currentlySelectedPaymentMethod.id : undefined,
            pricing: this.currentlySelectedPricing.id,
            client_nonce: '',
            referral: getCookie('referral'),
            locale: this.localisationService.getLanguage(),
            set_discount: this.getLanguagePricingAmount(this.currentlySelectedPricing).discount_monthly_price.length > 0 && this.currentUserIsReferral === true,
            discount_code: this.discountCode ? this.discountCode.code : null,
            influencer_id: this.influencer ? this.influencer.influencer.id : null,
            charge_yearly: this.showYearlyPricing,
            only_price: true
        });
    };
    PricingComponent.prototype.back = function () {
        this.showBraintree = false;
    };
    PricingComponent.prototype.getLanguagePricingAmount = function (pricing) {
        var language = this.localisationService.getLanguage();
        for (var amountIndex in pricing.amounts) {
            if (pricing.amounts[amountIndex].language.country_code === language) {
                // @ts-ignore
                return pricing.amounts[amountIndex];
            }
        }
        return null;
    };
    PricingComponent.prototype.bootBraintree = function () {
        var _this_1 = this;
        this.showBraintree = true;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.pricingService.braintreeGenerateClientToken().subscribe(function (clientToken) {
            var params = {
                authorization: clientToken.client_token,
                container: '#dropin-container',
                threeDSecure: true,
                paypal: { flow: 'vault' }
            };
            if (_this_1.localisationService.getLanguage() === Languages.Bulgarian) {
                params['translations'] = _this_1.braintreeBgTranslationConfig.translations;
            }
            // @ts-ignore
            braintree.dropin.create(params, function (createErr, instance) {
                _this_1.braintreeInstance = instance;
                _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
        });
    };
    PricingComponent.prototype.createFreeSubscription = function () {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        var setDiscountOnFree = parseFloat(this.getLanguagePricingAmount(this.currentlySelectedPricing).monthly_price) <= 0 && parseFloat(this.getLanguagePricingAmount(this.currentlySelectedPricing).discount_monthly_price) > 0;
        this.pricingService
            .createSubscription({
            payment_method: this.currentlySelectedPaymentMethod ? this.currentlySelectedPaymentMethod.id : undefined,
            pricing: this.currentlySelectedPricing.id,
            referral: getCookie('referral'),
            locale: this.localisationService.getLanguage(),
            set_discount: setDiscountOnFree,
            discount_code: this.discountCode ? this.discountCode.code : null,
            influencer_id: this.influencer ? this.influencer.influencer.id : null,
            charge_yearly: this.showYearlyPricing
        })
            .subscribe(function (createSubscriptionResponseDTO) {
            _this_1.router.navigate(['dashboard']).then(function () {
                _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
        });
    };
    PricingComponent.prototype.openAllTooltips = function () {
        var _this = this;
        setTimeout(function () {
            _this.activeChecks.forEach(function (tooltip) {
                tooltip.open();
            });
        }, 100);
    };
    PricingComponent.prototype.onYearlyPricingToggleChange = function (custom_value) {
        if (custom_value === void 0) { custom_value = null; }
        if (custom_value !== null) {
            this.showYearlyPricing = custom_value;
        }
        else {
            this.showYearlyPricing = !this.showYearlyPricing;
        }
        this.openAllTooltips();
    };
    PricingComponent.prototype.isMobile = function () {
        return window.innerWidth <= this.mobileWidth;
    };
    PricingComponent.prototype.removeStar = function () {
        deleteCookie('star');
        this.localStorage.removeItem('star');
        this.load().subscribe();
    };
    PricingComponent.prototype.applyStarPrice = function (star_id) {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.starsService.getInfluencerById(star_id).subscribe(function (influencer) {
            _this_1.influencer = influencer;
            _this_1.changeDetectorRef.markForCheck();
            // tslint:disable-next-line:forin
            for (var pricingIndex in _this_1.pricings) {
                // tslint:disable-next-line:forin
                for (var amountIndex in _this_1.pricings[pricingIndex].amounts) {
                    // @ts-ignore
                    if (_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price <= 0) {
                        continue;
                    }
                    // @ts-ignore
                    _this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price = (parseFloat(_this_1.pricings[pricingIndex].amounts[amountIndex].monthly_price) + parseFloat(influencer.influencer.amount_monthly_bgn)).toFixed(2);
                    // @ts-ignore
                    _this_1.pricings[pricingIndex].amounts[amountIndex].yearly_price = (parseFloat(_this_1.pricings[pricingIndex].amounts[amountIndex].yearly_price) + parseFloat(influencer.influencer.amount_yearly_bgn)).toFixed(2);
                }
            }
            _this_1.pricings = _this_1.pricings.sort(function (a, b) { return +a.amounts[0].monthly_price - +b.amounts[0].monthly_price; });
            _this_1.changeDetectorRef.markForCheck();
            _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    };
    PricingComponent.prototype.isYettel = function () {
        return this.yettelToken != null && this.yettelToken.length > 0;
    };
    PricingComponent.prototype.generateThreeMonthsDate = function () {
        return moment().add(3, 'months').format('DD.MM.YYYY');
    };
    PricingComponent.prototype.onChooseYettel = function () {
        var _this_1 = this;
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);
        this.pricingService.createYettelSubscription()
            .subscribe(function () {
            _this_1.router.navigate(['dashboard']).then(function () {
                _this_1.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
            });
        });
    };
    return PricingComponent;
}());
export { PricingComponent };
